import { lazy } from 'react';

const PostJobPage = lazy(() => import('./PostJobPage'));
const BrowseTutorPage = lazy(() => import('./BrowseTutorPage'));


export { BrowseTutorPage, PostJobPage };
